export const SET_BAT_REPORT = 'SET_BAT_REPORT';

export const setBatReport = (reportPayload) => ({
  type: SET_BAT_REPORT,
  payload: reportPayload,
});
